'use client';
import React, { useState } from 'react';
import { Search, ChevronDown, MapPin } from 'lucide-react';
import { useRouter } from 'next/navigation';

const CITIES = ['Malang', 'Surabaya', 'Yogyakarta', 'Bandung'];

export default function BerandaHeader() {
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState('');
  const [cityOpen, setCityOpen] = useState(false);
  const [selectedCity, setSelectedCity] = useState('Malang');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      router.push(`/jelajahi-explore?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <div className="pt-6 pb-4">
      {/* Greeting */}
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="text-sm text-muted-foreground font-500 mb-1">Selasa pagi ☀️</p>
          <h1 className="text-2xl font-800 text-primary leading-tight">
            Where are we hanging
            <br />
            <span className="text-accent">today?</span>
          </h1>
        </div>

        {/* City Selector */}
        <div className="relative">
          <button
            onClick={() => setCityOpen(!cityOpen)}
            className="flex items-center gap-1.5 bg-secondary border border-border rounded-xl px-3 py-2 text-sm font-600 text-primary hover:border-accent transition-colors"
          >
            <MapPin size={14} className="text-accent" />
            {selectedCity}
            <ChevronDown size={14} className={`transition-transform ${cityOpen ? 'rotate-180' : ''}`} />
          </button>
          {cityOpen && (
            <div className="absolute right-0 top-full mt-2 bg-card border border-border rounded-xl shadow-card overflow-hidden z-20 w-40 animate-scale-in">
              {CITIES.map((city) => (
                <button
                  key={`city-${city}`}
                  onClick={() => { setSelectedCity(city); setCityOpen(false); }}
                  className={`w-full text-left px-4 py-3 text-sm font-500 hover:bg-secondary transition-colors ${selectedCity === city ? 'text-accent font-600' : 'text-foreground'}`}
                >
                  {city}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Search Bar */}
      <form onSubmit={handleSearch} className="relative">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Cari tempat, kopi, atau vibe..."
          className="input-field pl-11 pr-14 h-12 text-sm"
        />
        {searchQuery && (
          <button
            type="submit"
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-accent text-white rounded-lg px-3 py-1.5 text-xs font-600 hover:bg-[#E06828] transition-colors"
          >
            Cari
          </button>
        )}
      </form>
    </div>
  );
}